// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1GK33","cell":"ColumnAccessor_cell__25OiU","firstCellAccent":"ColumnAccessor_firstCellAccent__1-YF9"};